import { Route, Routes } from "react-router-dom"
import GeneralSetting from "./pages/GeneralSetting"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<GeneralSetting />} />
    </Routes>
  )
}
